import Clamp from "react-multiline-clamp";
import AmountUtils from "../../Utils/AmountUtils";
import { Box, Button, Grid, Typography } from "@mui/material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import AnalyticsService from "../../Services/AnalyticsService";
import _ from "lodash";
import MiscUtils from "../../Utils/MiscUtils";
import { East } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PlannedProductCard = (props) => {
  let productDetails = props?.product;
  const navigate = useNavigate();

  const handleBuyNowClicked = () => {
    const productSkus = _.join(productDetails?.productSalesGroupSKUs, ",");
    AnalyticsService.pushEvent(`Button Clicked`, {
      page: "vyapaar",
      type: "Buy Now",
      title: productDetails?.productName || "",
      skuCode: productSkus,
    });
    productDetails?.productSalesGroupSKUs?.length > 1
      ? navigate(`/products-list/${productSkus}`)
      : navigate(`/products/${productSkus}`);
  };

  const shouldShowData = () => {
    return (
      productDetails?.plannedPurchaseAmount > 0 &&
      props?.partnerStatsDropdownFilter !== "lastFinancialYear"
    );
  };
  return (
    <Box>
      <Grid
        container
        sx={{
          borderRadius: "16px",
          marginTop: "12px",
          border: "1px solid #ffffff",
          background: "#ffffff",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            marginLeft: "5px",
          }}
        >
          <Grid
            container
            direction={"row"}
            sx={{
              padding: "6px 6px 2px 10px",
            }}
          >
            <Grid
              item
              xs={2}
              sx={{
                minHeight: "36px",
                marginBottom: "6px",
              }}
            >
              <img
                src={
                  productDetails?.productSalesGroupImage &&
                  productDetails?.productSalesGroupImage !== ""
                    ? productDetails?.productSalesGroupImage
                    : `/icons/dummy.jpeg`
                }
                alt=""
                height="48px"
                min-height="48px"
                width="48px"
                min-width="48px"
              />
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                minHeight: "36px",
                marginBottom: "6px",
              }}
            >
              <Clamp lines={2} maxLines={2}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                    marginTop: "6px",
                    marginLeft: "4px",
                  }}
                >
                  {productDetails?.productSalesGroup &&
                  productDetails?.productSalesGroup !== ""
                    ? productDetails.productSalesGroup
                    : ""}
                </Typography>
              </Clamp>
            </Grid>
            <Grid
              item
              xs={3}
              sx={{
                marginBottom: "6px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {shouldShowData() && (
                <Box
                  sx={{
                    height: "45px",
                    width: "45px",
                  }}
                >
                  <CircularProgressbar
                    value={MiscUtils.convertToPercentage(
                      productDetails.netRevenue,
                      productDetails?.plannedPurchaseAmount
                    )}
                    text={
                      <tspan
                        dy={5}
                        dx={
                          MiscUtils.convertToPercentage(
                            productDetails.netRevenue,
                            productDetails?.plannedPurchaseAmount
                          ).length >= 3
                            ? -25
                            : -22
                        }
                        fontWeight={600}
                      >
                        {MiscUtils.convertToPercentage(
                          productDetails.netRevenue,
                          productDetails?.plannedPurchaseAmount
                        )}
                        %
                      </tspan>
                    }
                    counterClockwise
                    strokeWidth={14}
                    styles={buildStyles({
                      textColor: "#000000",
                      pathColor: "#00733E",
                      trailColor: "#4F4F4F20",
                      textSize: "23px",
                      textAlign: "center",
                    })}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            justifyContent: "space-between",
            padding: "4px 6px 6px 10px",
            marginTop: "-10px",
          }}
        >
          <Grid
            item
            xs={2.7}
            sx={{
              borderRadius: "10px",
              border: "1px solid #055EC820",
              background: "#055EC810",
              padding: "3px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "800",
                color: "#1C1C1C90",
                textTransform: "uppercase",
                marginTop:
                  productDetails?.plannedPurchaseAmount > 0 ? "0px" : "2px",
              }}
            >
              {props?.partnerStatsDropdownFilter === "lastFinancialYear"
                ? `FY'${props?.currentFinancialYear - 1} PLAN`
                : `FY'${props?.currentFinancialYear} PLAN`}
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
                color:
                  props?.partnerStatsDropdownFilter === "lastFinancialYear"
                    ? "#9D2123"
                    : productDetails?.plannedPurchaseAmount > 0
                      ? "#4F4F4F"
                      : "#9D2123",
              }}
            >
              {props?.partnerStatsDropdownFilter === "lastFinancialYear"
                ? "₹0"
                : `₹${AmountUtils.formatNumberWithSuffix(productDetails?.plannedPurchaseAmount)}`}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2.7}
            sx={{
              borderRadius: "10px",
              border: "1px solid #00733E20",
              background: "#00733E10",
              padding: "4px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "800",
                color: "#1C1C1C90",
                textTransform: "uppercase",
              }}
            >
              Purchased
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#00733E",
              }}
            >
              ₹{AmountUtils.formatNumberWithSuffix(productDetails.grossRevenue)}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2.7}
            sx={{
              borderRadius: "10px",
              border: "1px solid #9D212320",
              background: "#9D212310",
              padding: "4px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "800",
                color: "#1C1C1C90",
                textTransform: "uppercase",
              }}
            >
              Returned
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#9D2123",
              }}
            >
              ₹
              {AmountUtils.formatNumberWithSuffix(productDetails.returnRevenue)}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2.7}
            sx={{
              borderRadius: "10px",
              border: "1px solid #F8D14940",
              background: "#F8D14930",
              padding: "4px",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "800",
                color: "#1C1C1C90",
                textTransform: "uppercase",
              }}
            >
              Net
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#A06600",
              }}
            >
              ₹{AmountUtils.formatNumberWithSuffix(productDetails.netRevenue)}
            </Typography>
          </Grid>
        </Grid>
        {productDetails?.productSalesGroupSKUs?.length > 0 && (
          <Grid
            container
            alignItems={"flex-end"}
            justifyContent={"flex-end"}
            sx={{
              paddingBottom: "8px",
              paddingTop: "6px",
            }}
          >
            <Grid item xs={8}></Grid>
            <Grid
              item
              xs={4}
              sx={{
                marginRight: "14px",
              }}
            >
              <Button
                fullWidth
                onClick={handleBuyNowClicked}
                variant="outlined"
                endIcon={<East />}
                size={"medium"}
                sx={{
                  textTransform: "capitalize",
                  borderRadius: "16px",
                  fontWeight: 700,
                  fontSize: "14px",
                  padding: "0px 5px",
                  "& .MuiButton-endIcon": {
                    marginLeft: "2px",
                    marginTop: "2px",
                  },
                }}
              >
                Buy Now
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PlannedProductCard;
